module.exports = __webpack_public_path__ + "static/media/icon-how-it-works3.22b9d7dd.svg";